import {
    entityEditFragment,
    entityViewFragment,
    followersFragment,
} from 'js/components/EntityActions/fragments/entity'
import { featuredViewFragment } from 'js/lib/fragments/featured'
import { ownerFragment } from 'js/lib/fragments/owner'

import { customContentTypeFragment } from './customContentType'

const formResponseFragment = `
    formResponse {
        guid
        value
        field {
            fieldType
        }
    }
`

export const genericArticleEditFragment = `
    ... on GenericArticle {
        ${entityEditFragment}
        ${formResponseFragment}
    }
`

export const genericArticleViewFragment = `
    ... on GenericArticle {
        ${entityViewFragment}
        ${formResponseFragment}
        contentType {
            ${customContentTypeFragment}
        }
        ${followersFragment}
    }
`

export const genericArticleListFragment = `
    ... on GenericArticle {
        guid
        localTitle
        localExcerpt
        title
        url
        excerpt
        description
        richDescription
        isHighlighted
        ${featuredViewFragment}
        subtype
        tagCategories {
            name
            values
        }
        tags
        statusPublished
        timePublished
        isBookmarked
        isPinned
        canBookmark
        canEdit
        canArchiveAndDelete
        commentCount
        canComment
        hasVoted
        votes
        isTranslationEnabled
        ${ownerFragment}
        group {
            guid
            ... on Group {
                isClosed
                name
                url
                membership
                isMembershipOnRequest
                isJoinButtonVisible
            }
        }
        publishRequest {
            status
        }
        contentType {
            ${customContentTypeFragment}
        }
    }
`
